<div>
    <mat-button-toggle-group [(ngModel)]="driverOrVeh" (change)="onValChange()" aria-label="Font Style">
        <mat-button-toggle value="vehicleView">Vehicle</mat-button-toggle>
        <mat-button-toggle value="driverView">Driver</mat-button-toggle>
      </mat-button-toggle-group>
</div>
